import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

const getDefaultUser = () => {
  let user = localStorage.getItem("user");
  if (user && user !== "undefined") {
    return JSON.parse(user);
  } else {
    return null;
  }
};
const initialState = {
  user: getDefaultUser() || {},
  singleUser: null,
};

export const login = createAsyncThunk(
  "auth/login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("/auth/login", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("/auth/otp/verify", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "/auth/change-password",
        payload,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("/auth/forgot-password", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (payload) => {
    return await apiInstance.post("/auth/reset-password", payload);
  }
);

export const getSingleStudent = createAsyncThunk(
  "user/userById",
  async (selectId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/user/${selectId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userEditData = createAsyncThunk(
  "user/edit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/user/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getGoal = createAsyncThunk(
  "user/allGoal",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/goal`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getExamType = createAsyncThunk(
  "user/allExamType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/exam-type`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    logOut: (state) => {
      state.user = {};
      localStorage.clear();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, action) => {
      state.user = action.payload.data;
      localStorage.setItem("user", JSON.stringify(action.payload.data));
    });
    builder.addCase(getSingleStudent.fulfilled, (state, action) => {
      state.singleUser = action.payload.data;
    });
    builder.addCase(getGoal.fulfilled, (state, action) => {
      state.goalData = action.payload.data;
    });
    builder.addCase(getExamType.fulfilled, (state, action) => {
      state.examTypeData = action.payload.data;
    });
  },
});

export default authSlice.reducer;
export const { logOut, clearUser } = authSlice.actions;

export const selectUser = (state) => {
  return state.auth.user;
};

export const useUser = () => {
  const user = useSelector(selectUser);
  localStorage.setItem("user", user ? JSON.stringify(user) : undefined);

  return useMemo(() => ({ user }), [user]);
};
